// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_NovidadesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de GET /chamados/novidades — a lista do painel do sino.
 *
 * SEPARADA do contador (`/chamados/nao-lidos`) de propósito, e a separação é
 * a decisão que mantém tudo barato: o CONTADOR é consultado de minuto em
 * minuto, por usuário logado, e devolve um número. Esta LISTA é buscada UMA
 * VEZ, quando a pessoa clica no sino.
 *
 * Juntar as duas — "já que a requisição sai, manda as linhas" — faria o filtro
 * e a serialização rodarem (usuários × 60) vezes por hora para um painel que
 * quase ninguém abre.
 */
import type { Chamados_NovidadeRow } from './Chamados_NovidadeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Chamados_NovidadesResponseDados {
rows: Chamados_NovidadeRow[]
total: number
}

export type Chamados_NovidadesResponse = ApiResponse<Chamados_NovidadesResponseDados>;

registerResponseContract('Chamados_NovidadesResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:        { type: 'number',  required: false },
      origem:    { type: 'string',  required: false },
      titulo:    { type: 'string',  required: false },
      descricao: { type: 'string',  required: false },
      quando:    { type: 'string',  required: false },
      rota:      { type: 'string',  required: false },
      enfase:    { type: 'string',  required: false },
    },
  },
  total: { type: 'number',  required: true },
})
